module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-aichi-2-3f7ac3e3c13e01d70c80e8a484f16b45.png";